// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2099i","outlined":"Button_outlined__3YyA8"};